import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledSignalsListTypesWrapper = styled(FlexRow)`
    flex-wrap: wrap;
    gap: 8px;
`;

export const StyledSignalListTypeItemContent = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: row;
`;

export const StyledSignalTitle = styled.div`
    display: flex;
    align-items: center;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    line-height: 16px;
`;

export const StyledSignalListTypeItemContainer = styled.button<{ $clickable?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 285px;
    padding: 16px 20px;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${colorsPalettes.carbon[100]};
    background: ${colorsPalettes.carbon[0]};
    font: inherit;
    text-align: left;
    cursor: ${(p) => (p.$clickable ? "pointer" : "default")};
    transition: border-color 0.2s ease;

    &:hover {
        border-color: ${(p) => (p.$clickable ? colorsPalettes.blue[400] : colorsPalettes.carbon[100])};

        svg path {
            fill: ${(p) => (p.$clickable ? colorsPalettes.blue[400] : undefined)};
        }
    }
`;

export const StyledSignalCount = styled.div`
    display: flex;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
`;
